import { render, staticRenderFns } from "./eduHome.vue?vue&type=template&id=3ab02237&scoped=true&"
import script from "./eduHome.vue?vue&type=script&lang=js&"
export * from "./eduHome.vue?vue&type=script&lang=js&"
import style0 from "./eduHome.vue?vue&type=style&index=0&id=3ab02237&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab02237",
  null
  
)

export default component.exports